import classNames from 'classnames';

import { PictureElement } from '@/pictureElement/Picture';
import { rewriteImageSrc } from '@/utils/rewriteImageSrc';

interface Props extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  className?: string;
}

const Image = ({ src, alt, className, style }: Props) => {
  const imgSrc = rewriteImageSrc(src);

  return (
    <PictureElement src={imgSrc}>
      <img alt={alt} src={imgSrc} style={style} className={classNames('w-full object-cover h-auto', className)} />
    </PictureElement>
  );
};

export default Image;
